const list = {
    or: 'sau',
    and: 'și',
    separator: ',',
};
export default Object.freeze(list);
